import { DebouncedFunc } from 'lodash';
import { useCallback } from 'react';

import { debounce } from 'shared/lib/lodash/lodash';

type DebouncedCallback = (...params: Array<any>) => void | Promise<void>;

export function useDebouncedCallback(
    callback: DebouncedCallback,
): DebouncedFunc<DebouncedCallback> {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(debounce(callback, 500), []);
}

export function cancelDebouncedCallback(
    debouncedCallback: Pick<DebouncedFunc<DebouncedCallback>, 'cancel'>,
) {
    debouncedCallback.cancel();
}
